import React from 'react';
import { StarIcon } from 'lucide-react';
import type { Testimonial } from '../data/testimonials';
interface TestimonialsProps {
  testimonials: Testimonial[];
  title?: string;
  background?: 'paper' | 'white';
}
export function Testimonials({
  testimonials,
  title,
  background = 'white'
}: TestimonialsProps) {
  return <section aria-labelledby={title ? 'testimonials-heading' : undefined} aria-label={title ? undefined : 'Provider results'} className={background === 'white' ? 'bg-white' : 'bg-paper'} data-id="element-206" data-mp="3b01hpf7u80u5">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-8 md:py-28" data-id="element-207" data-mp="31yl7b7h0vypx">
        {title && <h2 id="testimonials-heading" className="mx-auto mb-14 max-w-[38rem] text-center font-serif text-[28px] font-semibold leading-[1.15] tracking-[-0.01em] text-ink md:text-[38px]" data-id="element-208" data-mp="2x11tg8o8lnyi">
            {title}
          </h2>}

        <ul className="grid gap-6 md:grid-cols-3" data-id="element-209" data-mp="qbetra4gihhd">
          {testimonials.map((item, index) => <li key={index} className="flex flex-col border border-brass/30 bg-white p-7 shadow-paper rounded-sharp" data-id="element-210" data-mp="h4wuw2gayci7" data-mpi={index}>
              <div className="flex gap-1" aria-label="Five out of five stars" data-id="element-211" data-mp="77s7y0emud0c">
                {Array.from({
              length: 5
            }).map((_, star) => <StarIcon key={star} className="h-3.5 w-3.5 fill-brass text-brass" aria-hidden="true" data-id="element-212" data-mp="c7wrjzau7nus" data-mpi={star} />)}
              </div>

              <blockquote className="mt-5 flex-1 font-serif text-[19px] italic leading-[1.45] text-ink" data-id="element-213" data-mp="14ur66fkz3t0c">
                {item.quote}
              </blockquote>

              <figure className="mt-6 flex items-center gap-3 border-t border-brass/25 pt-4" data-id="element-214" data-mp="v4xulektzdw3">
                <img src={item.photo} alt={`${item.name}, ${item.role} in ${item.city}`} width={96} height={96} loading="lazy" decoding="async" className="h-11 w-11 shrink-0 border border-brass/30 object-cover rounded-sharp" data-id="element-215" data-mp="1iv1yln1xlfnm" />
                <figcaption className="font-mono text-[10px] uppercase leading-[1.5] tracking-label text-slate" data-id="element-216" data-mp="1ohav0gjcqnpo">
                  <span className="block text-ink" data-id="element-217" data-mp="1jihqhdm1m71n">{item.name}</span>
                  {item.role} · {item.city}
                </figcaption>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}